import Location from "./location";
import ApiKeys from "./apiKeys";
import Utility from "../helpers/utility";
import { clientPlatform, defaultStoreId, mid } from "./apiEndpoints";
import localStorageFunc from "../helpers/localStorageFunc";
// import { MINIAPP } from "../helpers/paymentConstants";
// import END_POINT from '../../../static/env-config.json'
const onDemandApiAuthrization =
  window._siteProps_?.props?.onDemandApiAuthrization;
const headers = (payload) => {
  let headers = {
    // apiKey: ApiKeys.CATALOG_MENU_API_KEY,

    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
    "Access-Control-Allow-Headers": "*",
    Api_key: ApiKeys.CATALOG_MENU_API_KEY,
    client_type: "web app-chrome", // @todo: value to be calculated
  };

  let credentials = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.credentials
    : "";
  let value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers
    : "";

  // @todo comment credentials block in future when not needed
  // @todo remove authtoken as well since it will be replaced by Authorization
  if (credentials) {
    if (value && !value.isLoggedIn) {
      // for (const [key, val] of Object.entries(credentials)) {
      //   headers[key.toLowerCase()] = val;
      // }
      if (credentials?.accessKeyId) {
        headers["Authtoken"] = credentials.accessKeyId;
      }
    } else {
      if (credentials?.accessKeyId) {
        headers["Authtoken"] = credentials.accessKeyId;
      }
    }
  }

  if (credentials?.accessToken) {
    // headers["Authorization"] = credentials.accessToken;
    headers["Authtoken"] = credentials.accessToken;
  }

  // Authorization header required for new services
  // if (value && value.accessToken) {
  //   headers["Authorization"] = value.accessToken;
  // }

  value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.userId
    : "";
  if (value) {
    headers["userid"] = value;
  }

  headers["x-forwarded-for-requestid"] = Utility.getTimePrefixWith(value);
  // @todo remove hardcoded store id
  value = localStorage.lastLocationNew
    ? Utility.tryJsonParse(localStorage.lastLocationNew)[0]?.recent
        ?.advanceOrderStoreId
    : defaultStoreId;

  if (value) {
    headers["storeid"] = value;
  } else {
    let storeid = localStorage.storeId || "";
    if (storeid) {
      headers["storeid"] = storeid;
    } else {
      headers["storeid"] = Location.defaultStoreId;
      localStorage.storeId = Location.defaultStoreId;
    }
  }

  value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.cartId
    : "";
  if (value) {
    headers["cartid"] = value;
  }

  value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.deliveryType
    : "";
  if (value) {
    headers["deliverytype"] = value;
  }

  if (payload && payload.withRefreshToken) {
    if (credentials) {
      value = localStorage.userInfo
        ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.credentials
            ?.refreshToken
        : "";
      if (value) {
        // headers["Authorization"] = value;
        headers["Authtoken"] = value;
      }
    }
  }

  if (payload && payload.mid) {
    headers["mid"] = mid;
  }
  if (payload && payload.xTenantID) {
    headers["X-TenantID"] = "dominos_IN";
  }
  // @todo remove mobile header after gateway implementation at BE
  // if (payload && payload.withMobileNo) {
  //   value = localStorage.userInfo
  //     ? Utility.tryJsonParse(localStorage.userInfo)?.userData?.mobile
  //     : "";
  //   if (value) {
  //     headers["mobile"] = value;
  //   }
  // }
  if (payload && payload.withAuthorizationKey) {
    headers["Authorization"] = onDemandApiAuthrization;
  }

  value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.isLoggedIn
    : false;
  // headers["loggedInUser"] = value;
  headers["isLoggedIn"] = value;
  headers["payment_mode"] = localStorageFunc.getPaymentOfferMode()?.paymentMode;

  headers["tenantKey"] = ApiKeys.TENANT_KEY;
  headers["tenant"] = ApiKeys.TENANT;
  headers["tenant-Id"] = ApiKeys.TENANT_ID;
  headers["channelId"] = ApiKeys.CHANNEL_ID;
  headers["source"] = "PWA18";
  // headers["source"] = clientPlatform;

  value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.deliveryType
    : "D";
  headers["orderType"] = value;
  return headers;
};

export const ssoHeaders = (payload) => {
  let headers = {
    apiKey: ApiKeys.CATALOG_MENU_API_KEY,
    client_type: "web app-chrome", // @todo: value to be calculated
  };
  let value = localStorage.userInfo;
  if (payload && !payload.withoutAuthorization) {
    value = localStorage.userInfo
      ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.credentials
      : "";
    if (value && value.accessToken) {
      headers["Authorization"] = value.accessToken;
    }
  }
  value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.userId
    : "";
  if (value) {
    headers["userid"] = value;
  }

  headers["x-forwarded-for-requestid"] = Utility.getTimePrefixWith(value);

  value = localStorage.lastLocationNew
    ? Utility.tryJsonParse(localStorage.lastLocationNew)[0]?.recent
        ?.advanceOrderStoreId
    : "";
  if (value) {
    headers["storeid"] = value;
  } else {
    let storeid = localStorage.storeId || "";
    if (storeid) {
      headers["storeid"] = storeid;
    } else {
      headers["storeid"] = Location.defaultStoreId;
      localStorage.storeId = Location.defaultStoreId;
    }
  }
  value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.cartId
    : "";
  if (value) {
    headers["cartid"] = value;
  }

  value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.deliveryType
    : "";
  if (value) {
    headers["deliverytype"] = value;
  }

  value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.isLoggedIn
    : false;

  // headers["loggedInUser"] = value;
  headers["isLoggedIn"] = value;

  if (payload && payload.withRefreshToken) {
    value = localStorage.userInfo
      ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.credentials
          ?.refreshToken
      : "";
    if (value) {
      headers["Authorization"] = value;
    }
  }

  // if (payload && payload.withMobileNo) {
  //   value = localStorage.userInfo
  //     ? Utility.tryJsonParse(localStorage.userInfo)?.userData?.mobile
  //     : "";
  //   if (value) {
  //     headers["mobile"] = value;
  //   }
  // }

  return headers;
};

export default headers;
